import { ButtonWithTracking } from '@hc-frontend/shells-shared';
import { useRouter } from 'next/navigation';
import React, { useEffect } from 'react';

import type { SurveyPlateTransitionOptionsProps } from './survey-plate-transition-options.types';

export function SurveyPlateTransitionOptions({
  continueButtonLabel = 'Continue',
  backButtonLabel = 'Back',
  continueButtonDisabled,
  metricTags,
  handleSkipClick,
  showSkipButton = false,
  showBackButton = false,
  showContinueButton = true,
  isPending,
  testIdPrefix,
}: SurveyPlateTransitionOptionsProps) {
  const router = useRouter();

  useEffect(() => {
    const element = document.getElementById('plate-animation-container');
    element?.classList.toggle('animate-plate-pulse', isPending);
  }, [isPending]);

  return (
    <div className="hc-center-layout hc-stack-layout my-16-16">
      <div className="hc-center-layout my-16-16 flex flex-col flex-wrap justify-center gap-12-12">
        {showContinueButton ? (
          <ButtonWithTracking
            id="next-button"
            data-testid={
              testIdPrefix ? `${testIdPrefix}-continueButton` : undefined
            }
            variant="primary-card"
            type="submit"
            className="px-32-60"
            disabled={isPending || continueButtonDisabled}
            metricTags={metricTags}
            name="action"
            value="continue"
          >
            {continueButtonLabel}
          </ButtonWithTracking>
        ) : null}
        {showBackButton ? (
          <ButtonWithTracking
            id="back-button"
            data-testid={
              testIdPrefix ? `${testIdPrefix}-backButton` : undefined
            }
            variant="text"
            type="button"
            className="font-regular text-gray-400 underline"
            disabled={isPending}
            metricTags={metricTags}
            onClick={() => {
              router.back();
            }}
          >
            {backButtonLabel}
          </ButtonWithTracking>
        ) : null}
      </div>
      {showSkipButton ? (
        <ButtonWithTracking
          id="skip-button"
          data-testid={testIdPrefix ? `${testIdPrefix}-skipButton` : undefined}
          variant="text"
          type="submit"
          className="font-regular text-gray-400 underline"
          metricTags={metricTags}
          disabled={isPending}
          onClick={(event) => {
            if (handleSkipClick) {
              handleSkipClick(event);
            }
          }}
          name="action"
          value="skip"
        >
          Skip
        </ButtonWithTracking>
      ) : null}
    </div>
  );
}

export default SurveyPlateTransitionOptions;
